import React from 'react';
import _get from 'lodash.get';
import {
  Labeled,
  TextField,
  useGetIdentity,
  useRecordContext,
} from 'react-admin';
import { IconButton } from '@material-ui/core';
import { FileCopySharp } from '@material-ui/icons';
import { USER_TYPE } from '../constants/statuses';

export const TextFieldWithCopy = (props) => {
  const {
    label,
    source,
    removeLable = false,
    prefix = '',
  } = props;
  const record = useRecordContext(props);
  const { identity } = useGetIdentity();
  const { type } = identity || {};
  const copy = (event) => {
    event.preventDefault();
    const value = event.currentTarget.previousElementSibling.innerText;
    window.navigator.clipboard.writeText(type === USER_TYPE.MANAGER ? `${prefix}${value}` : value);
  };

  const sourceValue = _get(record, source);
  const copyButton = sourceValue
    ? (
      <IconButton
        color="secondary"
        size="small"
        onClick={(event) => copy(event)}
      >
        <FileCopySharp />
      </IconButton>
    )
    : null;

  return (
    <div className="text-field-with-icon-button">
      {removeLable
        ? (
          <>
            <TextField label={false} {...props} />
            {copyButton}
          </>
        )
        : (
          <Labeled label={label || source}>
            <>
              <TextField {...props} />
              {copyButton}
            </>
          </Labeled>
        )}
    </div>
  );
};
